import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Form } from "react-form";

// Import website components
import { Modal, ProgramEditForm } from "../../components";

// Import styling
import "../../styles/components/_programs.scss";
import "../../styles/components/modals/_edit-program.scss";
import "../../styles/components/_programs.scss";

import * as select from "../../reducers";
import * as actionsPrograms from "../../actions/programs";
import * as actionsModals from "../../actions/modals";

import "../../styles/components/modals/_edit-program.scss";
import { MdLocationCity, MdPerson } from "react-icons/md";

function ProgramModal({ selectedProgram, savePrograms, deletePrograms, isOpen, setModalProgramEditClosed }) {
  const renderAvatar = useMemo(() => {
    const placeholderAvatar =
      selectedProgram?.charity_type?.toLowerCase() === "person" ? (
        <div className="program__profile-pic">
          <MdPerson size={120} />
        </div>
      ) : (
        <div className="program__profile-pic">
          <MdLocationCity size={120} />
        </div>
      );

    return selectedProgram?.charity_avatar ? (
      <img
        alt={selectedProgram.charity_avatar}
        className="program__profile-pic"
        src={"data:image/png;base64, " + selectedProgram.charity_avatar}
      ></img>
    ) : (
      placeholderAvatar
    );
  }, [selectedProgram]);

  // If there is no selected program, return NULL.
  if (!selectedProgram) {
    return null;
  }

  // If there is a selected program, return the modal allowing the user to edit the donation
  return (
    <Modal isOpen={isOpen} modalName="edit-program" onClose={setModalProgramEditClosed}>
      <div className="edit-program__recipient">
        <div className="program__content">
          {renderAvatar}
          <h2 className="program__recipient">{selectedProgram.donation_recipient}</h2>
          <p className="mb--24">{selectedProgram.donation_location}</p>
        </div>
      </div>
      <Form>
        <ProgramEditForm selectedProgram={selectedProgram} onClose={setModalProgramEditClosed} onDelete={deletePrograms} />
      </Form>
    </Modal>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedProgram: select.getSelectedProgram(state),
    isOpen: select.getProgramModalOpen(state),
  };
};

export default connect(mapStateToProps, {
  ...actionsPrograms,
  ...actionsModals,
})(ProgramModal);
